import {isLocalhost} from "./isLocalhost";

export const debugLocally = (...data) => isLocalhost() && console.log(...data)